import { UserData, UserLoginDataResponse } from './types';
import { SegmentTrackerInterface } from 'Common/segment';

export const segmentId = (loginHash: string, country: string) => `${country.toLocaleLowerCase()}_${loginHash}`;

// see https://segment.com/docs/connections/spec/identify/#traits for default names
const identifyUser = ({
    userData,
    country,
    segmentTracker,
}: {
    userData: UserLoginDataResponse | UserData;
    country: string;
    segmentTracker: SegmentTrackerInterface;
}) =>
    segmentTracker.identify(userData.loginHash ? segmentId(userData.loginHash, country) : '', {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        createdAt: userData.registeredAt,
        id: userData.id,
    });

export default identifyUser;
